import { apiFetch } from "@core/index";
import { buildQueryParams } from "@shared/utils/functions";
import { useQuery } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiEndpoint } from "../utils/constants";
import { IGetAllPartners, IPartnerRow } from "../utils/types";

export type PartnersListResponse = {
  data: IPartnerRow[];
  pagination: {
    total: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
};

export const useGetAllPartners = (config: IGetAllPartners) => {
  return useQuery<
    PartnersListResponse,
    Error,
    PartnersListResponse,
    (string | boolean | undefined)[]
  >({
    queryKey: [
      "partners",
      config.data.pageNumber,
      config.data.pageSize,
      config.data.includeInactive,
      config.data.referrerID ?? "",
      config.data.filterField ?? "",
      config.data.filterOperator ?? "",
      config.data.filterValue ?? "",
      config.data.username ?? "",
      config.data.titleID ?? "",
      config.data.partnerChannel ?? "",
      config.data.platform ?? "",
      config.data.invoiceParty ?? "",
      config.data.orderBy ?? "",
      config.data.order ?? "",
      config.data.updatedSince ?? "",
    ],
    queryFn: async () => {
      const queryString = buildQueryParams(config.data);

      const url = `${apiEndpoint}?${queryString}`;

      try {
        const data = await apiFetch<PartnersListResponse>(url);
        return data;
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Failed to fetch the Partners List.";

        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        });
        throw error;
      }
    },

    placeholderData: (prev) => prev,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
